(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rk-cart')) {
    customElements.define('rk-cart', class extends HTMLElement {
      connectedCallback() {
        this.timers = {};
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
      }

      get sectionId() {
        const section = this.closest('.shopify-section');
        return section ? section.id.replace('shopify-section-', '') : null;
      }

      onClick = (event) => {
        const step = event.target.closest('[data-qty-step]');
        const remove = event.target.closest('[data-remove]');
        if (step) {
          const input = step.closest('.rk-item').querySelector('.rk-qty__input');
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
          this.queue(input);
        } else if (remove) {
          event.preventDefault();
          this.update(remove.closest('.rk-item').dataset.line, 0);
        }
      };

      onChange = (event) => {
        if (event.target.matches('.rk-qty__input')) this.queue(event.target, 0);
        if (event.target.matches('#rk-cart-note')) {
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: event.target.value })
          });
        }
      };

      queue(input, delay = 350) {
        const line = input.closest('.rk-item').dataset.line;
        clearTimeout(this.timers[line]);
        this.timers[line] = setTimeout(() => this.update(line, parseInt(input.value, 10) || 0), delay);
      }

      async update(line, quantity) {
        const sectionId = this.sectionId;
        this.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              line: Number(line),
              quantity,
              sections: sectionId ? [sectionId] : [],
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message);
          const html = sectionId && data.sections && data.sections[sectionId];
          if (!html) return window.location.reload();
          const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(`shopify-section-${sectionId}`);
          const target = document.getElementById(`shopify-section-${sectionId}`);
          const swap = () => { target.innerHTML = fresh.innerHTML; };
          if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            document.startViewTransition(swap);
          } else {
            swap();
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        } catch (error) {
          this.removeAttribute('aria-busy');
          const status = this.querySelector('.rk-cart__status');
          if (status) status.textContent = error.message;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
